import { Box, Card, CardContent, Slider, Typography } from '@mui/material'
import type { SimulationInput, SimulationResults } from '../../api/types'
import { formatEUR2 } from '../../format'
import ComputedField from './ComputedField'
import FieldsGrid from './FieldsGrid'
import { financementFields, type FieldKey } from './formFields'

export default function FinancementCard({
  form,
  setForm,
  preview,
  setNum,
}: {
  form: SimulationInput
  setForm: React.Dispatch<React.SetStateAction<SimulationInput>>
  preview: SimulationResults
  setNum: (key: FieldKey, raw: string) => void
}) {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Financement
        </Typography>
        <FieldsGrid fields={financementFields} form={form} setNum={setNum} />
        <Box sx={{ my: 3 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
            Durée du prêt : {form.loanDurationYears} ans
          </Typography>
          <Box sx={{ px: 2 }}>
            <Slider
              value={form.loanDurationYears}
              onChange={(_, value) =>
                setForm((f) => ({ ...f, loanDurationYears: value as number }))
              }
              min={5}
              max={30}
              step={1}
              marks={[
                { value: 5, label: '5 ans' },
                { value: 30, label: '30 ans' },
              ]}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'grid',
            gap: 2,
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
          }}
        >
          <ComputedField
            label="Échéance mensuelle"
            value={preview.monthlyLoanPayment === 0 ? '' : formatEUR2(preview.monthlyLoanPayment)}
          />
          <ComputedField
            label="Intérêt du prêt sur la durée"
            value={preview.totalInterest === 0 ? '' : formatEUR2(preview.totalInterest)}
          />
        </Box>
      </CardContent>
    </Card>
  )
}
